class GlobalModal {

    constructor(){
        this.iFrame = document.getElementById('global-modal-iframe');
        this.bindOpenButtons();
        this.bindCloseButtons();
    }

    bindOpenButtons(){
        var self = this;

        jQuery(document).ready(function(){
            jQuery('[js-show-global-modal]').click(function(e){
                e.preventDefault();
                let src = jQuery(e.target).attr('js-show-global-modal');
                self.iFrame.src = src;
                jQuery('.global-modal-background').removeClass('d-none');
            });
        });
    }

    bindCloseButtons() {
        var self = this;

        jQuery(document).ready(function(){
            jQuery('#global-modal-close-btn').click(function(e){
                e.preventDefault();
                self.iFrame.src = '';
                jQuery('.global-modal-background').addClass('d-none');
            });
        });
    }

}

export default GlobalModal;